import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  TextField,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { getDentists } from "../../../api/dentistApi";
import { StyledButton } from "../../../common/components/Button";
import * as yup from "yup";
import { useSelector } from "react-redux";

const EditDentistDialog = ({
  open,
  onClose,
  onDentistUpdate,
  isSubmittingDentist,
}) => {
  const [dentists, setDentists] = useState();
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        dentistId: yup.string().required("Dentist is required."),
      })
    ),
  });
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user.roles.includes("Operations")) {
      const fetchDentists = async () => {
        const { data } = await getDentists();
        setDentists(data);
      };
      fetchDentists();
    }
  }, [user]);

  const handleUpdate = async (values) => {
    await onDentistUpdate(values);
    onClose();
  };

  const getLabel = (option) => {
    return `${option.firstName} ${option.lastName} - ${option.dentalClinicName}`;
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      {isSubmittingDentist && <LinearProgress />}
      <DialogTitle>Select Dentist</DialogTitle>

      <form onSubmit={handleSubmit(handleUpdate)}>
        <DialogContent dividers>
          {/* <StyledDataGrid autoHeight rows={schedule} columns={columns} /> */}
          <Controller
            control={control}
            name="dentistId"
            render={({ field: { onChange }, fieldState: { error } }) => (
              <Autocomplete
                autoHighlight
                options={dentists}
                onChange={(_, val) => {
                  onChange(val?.id || "");
                }}
                getOptionLabel={(option) => getLabel(option) || option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Dentist - Clinic"
                    error={Boolean(error)}
                    FormHelperTextProps={{ variant: "standard" }}
                    helperText={error && error.message}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {getLabel(option)}
                    </li>
                  );
                }}
                sx={{ width: "100%" }}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={onClose} theme="purple">
            Cancel
          </StyledButton>
          <StyledButton type="submit" theme="green">
            Save
          </StyledButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditDentistDialog;
